/*
*   File : holdings.js
*   Author : https://evoqins.com
*   Description : Holdings data page
*   Integrations : NA
*   Version : 1.0.0
*/

import React from 'react';

//CUstom components
import { DoughnutChart } from '../../../Component/Chart';
import { PrimaryButton } from '../../../Component/Buttons';

const Holdings = (props) => {

    const labels = props.chartData.map(item => item.label);
    const values = props.chartData.map(item => Number(item.value));
    const colors = props.chartData.map(item => item.color);

    return (
        <div className={`${props.subscription === true ? "" : "overflow-hidden h-400"} position-relative`}>
            <div className='pt-4'>
                <h4 className='mb-3 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-24px'>
                    Basket Constituents
                </h4>
                <div className='e-bg-magnolia border-radius-4 d-flex padding-10px-tb px-2 justify-content-between'>
                    <h6 className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                        Stocks
                    </h6>
                    <h6 className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                        Weightage
                    </h6>
                </div>
                <div className='p-2 '>
                    {
                        props.holdings.map((item, index) => (
                            <div key={index}
                                className='d-flex justify-content-between e-border-bottom-1px-anti-flash-white pb-2'>
                                <div>
                                    <p className='mb-1 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                                        {item.script_name}
                                    </p>
                                    <p className='mb-0 e-text-slate-gray e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                        {item.nse_exchange_symbol || item.bse_exchange_symbol}
                                    </p>
                                </div>
                                <p className='mb-0 e-text-primary-color e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                    {item.weight.toFixed(2)}%
                                </p>
                            </div>
                        ))
                    }
                    <div className='d-flex justify-content-between padding-12px-top'>
                        <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                            Total Weightage
                        </p>
                        <p className='mb-0 e-text-primary-color e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px'>
                            {/* {
                                    props.holdings.map(item => Number(item.weight)).reduce((a, b) => a + b).toFixed(0)
                                } */}
                            100%
                        </p>
                    </div>
                </div>

                {/* View rebalance */}
                {/* <div className={`${style.e_rebalance_card_wrapper} margin-32px-top border-radius-8 position-relative`}>
                        <div className={`${style.e_rebalance_card} border-radius-8 padding-20px-tb px-3`}>
                            <div className='d-flex'>
                                <div>
                                    <p className='mb-1 e-alt-font-lato e-font-14 e-text-primary-color e-font-weight-500 line-height-18px'>
                                        Rebalance Frequency
                                    </p>
                                    <p className='mb-0 e-alt-font-lato e-font-16 e-text-chinese-black e-font-weight-400 line-height-20px'>
                                        Quarterly
                                    </p>
                                </div>
                            </div>

                            <TextButton name="View rebalance history"
                                type={3}
                                className="mt-3"
                                icon={true} />
                        </div>

                        <img src={require("../../../Assets/Images/Basket/rebalance-icon.svg").default}
                            draggable={false}
                            className='position-absolute top--14px end-0'
                            alt='icon' />
                    </div> */}

                {/* Basket Composition */}
                <div className='pt-4 mt-2'>
                    <h4 className='mb-3 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-24px'>
                        Basket Composition
                    </h4>

                    <div className="height-40px-res progress-stacked border-radius-8 h-34">
                        {
                            props.marketCap.map((item, key) => (
                                <div style={{ width: `${item.value}%` }}
                                    className="progress h-100"
                                    role="progressbar"
                                    key={key} >
                                    <div style={{ backgroundColor: item.color }}
                                        className="progress-bar text-center">{item.value}%</div>
                                </div>
                            ))}
                    </div>
                    <div className='d-flex gap-26px pt-2 mt-1'>
                        {
                            props.marketCap.map((item, key) => (
                                <div className='d-flex gap-6px align-items-center' key={key}>
                                    <div style={{ backgroundColor: item.color }}
                                        className='e-bg-ocean-blue border-radius-32 w-10px h-10'></div>
                                    <p className='mb-0 e-alt-font-lato e-text-charleston-green e-font-16 e-font-weight-400 line-height-20px'>
                                        {item.label} - <span className='e-font-weight-600'>{item.value}%</span>
                                    </p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                {/* Category Breakdown chart */}
                <div className='pt-4 mt-2'>
                    <h4 className='mb-0 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-24px'>
                        Category Breakdown
                    </h4>

                    <div className='px-sm-5 pt-3 mt-1'>
                        <DoughnutChart data={values} labels={labels} colors={colors} />
                    </div>

                    <div className='padding-20px-top d-flex gap-2 flex-wrap'>
                        <div className="row row-cols-2 flex-wrap row-gap-12px">

                            {
                                props.chartData.map((item, index) => (
                                    <div className='d-flex gap-6px align-items-center' key={index}>
                                        <div style={{ background: item.color }}
                                            className='border-radius-32 w-10px h-10'></div>
                                        <p className='text-nowrap mb-0 e-alt-font-lato e-text-charleston-green e-font-16 e-font-weight-400 line-height-20px'>
                                            {item.label} - <span className='e-font-weight-600'>{item.value}%</span>
                                        </p>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>

            {/* Subscription overlay */}
            {
                props.subscription === false &&
                <div className='subscription-overlay position-absolute top-0 start-0 padding-50px-top text-center w-100 h-100'>
                    <img src={require("../../../Assets/Images/Basket/lock.png")}
                        draggable={false}
                        width={96}
                        height={148}
                        className='mt-5'
                        alt='portfolio border' />

                    <h4 className='col-sm-8 col-md-7 col-lg-6 mx-auto text-center padding-26px-top mb-1 e-text-primary-color e-primary-font-clash-display e-font-16 e-font-weight-500 line-height-22px'>
                        Subscribe to view  full holdings and see all your investments in detail
                    </h4>
                    <PrimaryButton name="Subscribe"
                        // status={loading}
                        // disabled={loading}
                        className="col-auto px-5 h-48 mt-3"
                        onPress={props.handleSubscribe} />
                </div>
            }
        </div>
    )
}

export default Holdings;
